import { render, staticRenderFns } from "./ItemGroup.vue?vue&type=template&id=cd7beef2&scoped=true"
import script from "./ItemGroup.vue?vue&type=script&lang=js"
export * from "./ItemGroup.vue?vue&type=script&lang=js"
import style0 from "./ItemGroup.vue?vue&type=style&index=0&id=cd7beef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7beef2",
  null
  
)

export default component.exports